import Box from "./Box";
import Image from "./Image";
import PropTypes from "prop-types";
import React from "react";

function FullWidth2UpGrid({ image1, image2 }) {
  return (
    <Box display="grid" gridTemplateColumns={["1fr", null, "1fr 1fr", null]}>
      <Box position="relative" height={0} pb="66%">
        <Image
          position="absolute"
          height="100%"
          width="100%"
          objectFit="cover"
          src={image1.url}
          alt={image1.title}
          bg="lightGrey"
        />
      </Box>
      <Box position="relative" height={0} pb="66%">
        <Image
          position="absolute"
          height="100%"
          width="100%"
          objectFit="cover"
          src={image2.url}
          alt={image2.title}
          bg="lightGrey"
        />
      </Box>
    </Box>
  );
}

export default FullWidth2UpGrid;

FullWidth2UpGrid.propTypes = {
  image1: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  image2: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};
